module.exports = __webpack_public_path__ + "img/Agents Only_th.505d6a6.png";